import { clsx } from 'clsx'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { RefObject, SyntheticEvent, useState } from 'react'
import { InferenceStore } from 'store/inference/InferenceStore'
import { Size } from 'util/size'
import css from './Video.module.scss'

type Props = {
  inference: InferenceStore
  onGood?: (good: boolean) => void
  onSize?: (size: Size) => void
  videoRef: RefObject<HTMLVideoElement>
}

export const Video = observer(({ inference, onGood, onSize, videoRef }: Props) => {
  const video = inference.videos[0]?.src
  const [good, setGood] = useState(false)
  const className = clsx(css.video, good && css.good)

  const onLoad = useLatestCallback((event: SyntheticEvent<HTMLVideoElement>) => {
    const { videoWidth: width, videoHeight: height } = event.currentTarget
    setGood(true)
    if (onGood) onGood(true)
    if (onSize) onSize({ width, height })
  })

  const onError = useLatestCallback(() => {
    setGood(false)
    onGood?.(false)
  })

  return <video ref={videoRef} className={className} muted autoPlay={false} playsInline
    onLoadedData={onLoad} onError={onError}>
    <source src={video} />
  </video>
})
